module.exports = __webpack_public_path__ + "img/poor.6bae834d.jpg";